import React from 'react';
import PropTypes from 'prop-types';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.core.css';
// import ReactQuill from 'react-quill';
import CKEditor from 'react-ckeditor-component';

const Editor = props => (
  <React.Fragment>
    <CKEditor
      className={(props.valid || typeof props.valid === 'undefined') ? '' : 'invalid'}
      activeClass="p10"
      content={props.content}
      config={{extraAllowedContent: 'div(*)', language: props.i18n.language, allowedContent: true }}
      events={{
        change: function (event){
          console.log(props);
          const newContent = event.editor.getData();
          props.setContent(newContent);
        },
      }}
    />
  </React.Fragment>
);

Editor.propTypes = {
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/cms/editor/Editor.jsx